<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="image"
      src="@/assets/IMG_9581.webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >

    <!-- Overlay sutil -->
    <div class="overlay"></div>

    <!-- Texto -->
    <div ref="textRef" class="text-overlay">
      <p class="firma">
  Con Cariño,<br>
        <span>Isabella Zorrilla</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const imageContainer = ref(null)

    onMounted(() => {
      // Animación de la imagen
      gsap.fromTo(
        image.value,
        { opacity: 0, scale: 1.15 },
        { 
          opacity: 1,
          scale: 1,
          duration: 1.6,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 95%', // 👈 entra cuando YA se ve
            once: true
          }
        }
      )

      // Animación del texto
      gsap.fromTo(
        textRef.value,
        { opacity: 0, y: 60 },
        { 
          opacity: 1,
          y: 0,
          duration: 1.8,
          delay: 0.6,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 95%',
            once: true
          }
        }
      )
    })

    return {
      image,
      textRef,
      imageContainer
    }
  }
}
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 600px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(100%);
  opacity: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.15),
    rgba(0, 0, 0, 0.45)
  );
  z-index: 2;
}

.text-overlay {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 3;
  opacity: 0;
  padding: 0 20px;
}

.firma {
  font-size: 18px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: 5px;
  font-family: 'titulos';
  font-size: 3rem;
  line-height: 2;
}
</style>